"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.callPromisesInChunks = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var CHUNK_LENGTH = 10;

var getArrayChunks = function getArrayChunks(arr) {
  var chunks = [];
  var i = 0;
  var arrLength = arr.length;

  while (i < arrLength) {
    chunks.push(arr.slice(i, i += CHUNK_LENGTH));
  }

  return chunks;
};
/**
 * Calls a promise function with the param given in an array.
 * @param params {Array} one param for each call
 * @param promiseFn a function that takes up to one argument
 * @returns {Promise<Array>}
 */
// export const callPromisesInChunks = async (params, promiseFn) => {
//   // TODO: the new chunk method always tries to parse 10 chunks, even if there are less files -> some are empty
//   return new Promise((resolve, reject) => {
//     const results = []
//     let startedPromises = 0
//     let donePromises = 0
//
//     const onPromiseDone = async (isInitialCall = false) => {
//       if (!isInitialCall) {
//         donePromises += 1
//         if (donePromises >= params.length) {
//           resolve(results)
//           return
//         }
//       }
//       promiseFn(params[startedPromises]).then((result) => {
//         results[startedPromises] = result
//         onPromiseDone()
//       })
//       if (!isInitialCall) {
//         startedPromises += 1
//       }
//     }
//
//     while (startedPromises < Math.min(CHUNK_LENGTH, params.length)) {
//       onPromiseDone(true)
//       startedPromises += 1
//     }
//   })
// }

/**
 * Calls a promise function with the param given in an array.
 * @param params {Array} one param for each call
 * @param promiseFn a function that takes up to one argument
 * @returns {Promise<Array>}
 */


var callPromisesInChunks = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, promiseFn) {
    var chunks, results, i, promises;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            chunks = getArrayChunks(params);
            results = [];
            i = 0;

          case 3:
            if (!(i < chunks.length)) {
              _context.next = 13;
              break;
            }

            promises = chunks[i].map(function (param) {
              return promiseFn(param);
            });
            _context.t0 = results;
            _context.next = 8;
            return _promise["default"].all(promises);

          case 8:
            _context.t1 = _context.sent;
            results = _context.t0.concat.call(_context.t0, _context.t1);

          case 10:
            i++;
            _context.next = 3;
            break;

          case 13:
            return _context.abrupt("return", _promise["default"].resolve(results));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function callPromisesInChunks(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.callPromisesInChunks = callPromisesInChunks;